import React from "react";
import { socialMedia } from "../../Data/Data";

const SocialMedia = () => {
  return (
    <div className="socialmedia" style={{ display: "flex" }}>
      {socialMedia.map(({ name, logo, link }) => (
        <li>
          {" "}
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            {logo}
          </a>
        </li>
      ))}
    </div>
  );
};

export default SocialMedia;
